module.exports = __webpack_public_path__ + "img/color-aws.66a08549.svg";